import { Img, Heading, Text, Button } from "../../components";
import React from "react";

export default function AboutOurProductSection() {
  return (
    <>
      {/* About Our Product Section */}
      <div className="flex flex-col md:flex-row items-center justify-between gap-8 px-12 md:px-10 sm:px-5">
        {/* Left Section - Text and Button */}
        <div className="flex flex-col items-start md:items-start gap-6 w-full md:w-1/2 sm:text-center md:text-left">
          <Button
            color="blue_A200_19"
            size="xs"
            className="min-w-[192px] rounded-[16px] px-4 font-dmsans font-bold tracking-[1.30px]"
          >
            ABOUT OUR PRODUCT
          </Button>
          <Heading
            size="heading13xl"
            as="h1"
            className="font-dmsans text-[37.43px] font-bold leading-10 text-color_style-01_neutrals-grey50 md:text-[38px] sm:text-[24px]"
          >
            Integrated, end-to-end Zwilling Labs Digital Twin Platform
          </Heading>
          <Text
            size="textxl"
            as="p"
            className="font-dmsans text-[14px] font-normal leading-6 text-white md:text-[18px] sm:text-[16px]"
          >
            Zwilling’s twin platform enables every step of your journey from
            connecting disparate data sources, creating and visualizing your
            digital twin machines and factory, to analyzing data and prescribing
            corrective actions. We actively support our customers in this
            journey. <br />
            Our comprehensive platform enables manufacturing industries to
            operate efficiently, paving the way for a sustainable future and
            advancing the global effort towards decarbonization.
          </Text>
        </div>

        {/* Right Section - Image */}
        <div className="w-full md:w-5/6">
          <Img
            src="images/img_image_63.webp"
            alt="Image"
            className="w-full h-auto object-contain sm:h-auto" // Ensure image scales properly
          />
        </div>
      </div>
    </>
  );
}
